import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { CmxHttpClient } from './api.service';
import { TranslationService } from './translation.service';
import { SessionService } from '@cemex-core/angular-services-v8';

@Injectable()
export class LanguageService {
  private languages = [];

  constructor(
    private cmxHttp: CmxHttpClient,
    private translationService: TranslationService,
    private sessionService: SessionService,
  ) {}

  private getLanguages() {
    const uri = `v3/im/languages`;
    return this.cmxHttp.get(uri).pipe(map((res) => (res['languages'] ? res['languages'] : [])));
  }

  private updateUserV6(userId: number, payload: any) {
    const uri = `v6/secm/users/${userId}`;
    return this.cmxHttp.patch(uri, payload);
  }

  public updateLanguage(language) {
    if (this.languages.length === 0) {
      this.getLanguages().subscribe((languages: any) => {
        if (languages) {
          this.languages = languages;
          this.saveLanguage(language);
        }
      });
    } else {
      this.saveLanguage(language);
    }
  }

  private saveLanguage(language: string) {
    this.translationService.setLanguage(language);
    const profile = this.sessionService.profile;
    const localLanguage = this.languages.find((lang) => lang.languageCode === language);
    const payload = {
      creationType: 'External',
      profile: {
        languageId: localLanguage.languageId,
      },
    };

    this.updateUserV6(profile.userId, payload).subscribe((res) => {
      profile['languageId'] = localLanguage.languageId;
      const session = this.sessionService.dataSession;
      session.profile = profile;
      this.sessionService.updateDataSession(session);
    });
  }
}
